/*
 * Entrega estimada de la ficha de producto. La app (pantalla Envíos) calcula la ventana de entrega según el
 * país del mercado, la hora de corte, los días hábiles y los festivos; aquí solo se pide y se da formato en el
 * idioma de la tienda. Si la app no devuelve fecha (apagado o país sin zona) el bloque sigue oculto.
 */
(function () {
  'use strict';

  function format(iso, locale) {
    // Mediodía UTC y zona UTC: el día no se mueve según la zona horaria del visitante.
    var date = new Date(iso + 'T12:00:00Z');
    try {
      return new Intl.DateTimeFormat(locale, { weekday: window.innerWidth < 480 ? undefined : 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(date);
    } catch (e) {
      return iso;
    }
  }

  function init(box) {
    if (box.dataset.hmBound === '1') return;
    box.dataset.hmBound = '1';
    var target = box.querySelector('[data-hm-delivery-date]');
    var locale = box.getAttribute('data-locale') || 'es';
    var url = box.getAttribute('data-url') + '?country=' + encodeURIComponent(box.getAttribute('data-country') || '');
    if (!target) return;
    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        if (!data || !data.enabled || !data.from) return;
        var from = format(data.from, locale);
        target.textContent = data.to && data.to !== data.from ? from + ' – ' + format(data.to, locale) : from;
        box.hidden = false;
      })
      .catch(function () {});
  }

  function boot() {
    document.querySelectorAll('[data-hm-delivery]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('product-info:loaded', boot);
  // El carrito lateral se vuelve a pintar al cambiar: las notas nuevas se inician solas.
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        boot();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
